import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { schema, defaultValues } from "./schema";
import { handleMessageError, handleMessageSuccess, handleMessageWarning } from "../../../../components/toast";
import { getReturnUpdated } from "../../../../util/libObject";

export const IndexHook = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	insert,
}) => {
	//#region useForm
	const {
		register,
		handleSubmit,
		setValue,
		reset,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		resolver: zodResolver(schema),
		defaultValues: defaultValues,
	});
	//#endregion

	//#region Controle de estado
	const [isInsert, setIsInsert] = useState(false);
	const [loading, setLoading] = useState(false);
	//#endregion

	//#region Fetch para popular formulário
	useEffect(() => {
		if (isOpenModalRegister) {
			const id =
				typeof selectedData[idTable] === "number" && !isNaN(selectedData[idTable]) ? selectedData[idTable] : 0;

			if (id > 0) {
				fetchData(id);
			} else {
				reset(defaultValues);
			}

			setIsInsert(id === 0);
		} else {
			if (setSelectData) setSelectData({});
			reset(defaultValues);
		}
	}, [isOpenModalRegister, selectedData]);

	const fetchData = async (id) => {
		try {
			setLoading(true);
			const response = await fetchID(id);

			if (response.data && typeof response.data === "object") {
				const data = Array.isArray(response.data) ? response.data[0] : response.data;

				const formatTime = (timeStr) => {
					if (!timeStr) return "";
					if (timeStr.includes("T")) {
						// e.g., "1899-12-30T08:00:00"
						const timePart = timeStr.split("T")[1];
						return timePart.substring(0, 5);
					} else if (timeStr.includes(":")) {
						return timeStr.substring(0, 5);
					}
					return timeStr;
				};

				Object.keys(data).forEach((field) => {
					if (field === "hora_abertura" || field === "hora_fechamento") {
						setValue(field, formatTime(data[field]));
					} else {
						setValue(field, data[field]);
					}
				});
			}
		} catch (error) {
			handleMessageError(error.message || error);
			handleCloseModalRegister();
		} finally {
			setLoading(false);
		}
	};
	//#endregion

	//#region onSubmit
	const handleOnSubmit = async (data) => {
		try {
			// Ajustar tempo caso faltar segundos (backend AsTime)
			const submitData = {
				...data,
				hora_abertura: data.hora_abertura.length === 5 ? data.hora_abertura + ":00" : data.hora_abertura,
				hora_fechamento:
					data.hora_fechamento.length === 5 ? data.hora_fechamento + ":00" : data.hora_fechamento,
			};

			const response = await insert(submitData);

			const returned = getReturnUpdated(response);
			const currentId = returned?.id_horario ?? 0;
			const oldID = data.id_horario;

			await reloadData(oldID, currentId);

			handleMessageSuccess("Horário salvo com sucesso.");
			reset(defaultValues);
			handleCloseModalRegister();
		} catch (error) {
			handleMessageWarning("Não foi possível salvar: " + (error.message || error));
		}
	};
	//#endregion

	//#region Fechar modal
	const handleCloseModalRegister = () => {
		const event = new CustomEvent(`${ident}`);
		window.dispatchEvent(event);
	};
	//#endregion

	return {
		//useForm
		register,
		control,
		errors,
		isSubmitting,
		setValue,
		handleSubmit,

		//hooks
		handleOnSubmit,
		handleCloseModalRegister,

		//variables
		isInsert,
		loading,
	};
};
